import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "card-item__name heading-m"
}
const _hoisted_3 = {
  key: 0,
  class: "label-mono-m"
}
const _hoisted_4 = {
  key: 1,
  class: "card-item__monitoring label-s"
}
const _hoisted_5 = {
  key: 1,
  class: "card-item__comment label-s"
}
const _hoisted_6 = {
  key: 2,
  class: "card-item__car-number heading-s"
}
const _hoisted_7 = {
  key: 3,
  class: "card-item__watch-list label-xs"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "card-item__watch-list_auto" }, null, -1)
const _hoisted_9 = {
  key: 5,
  class: "card-item__text-comment"
}
const _hoisted_10 = { class: "card-item__meta" }
const _hoisted_11 = { class: "card-item__summary" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" #")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "card-item__short-comment label-m"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NIcon = _resolveComponent("NIcon")!
  const _component_WatchListsGroup = _resolveComponent("WatchListsGroup")!
  const _component_NAttachments = _resolveComponent("NAttachments")!
  const _component_MetafieldListItem = _resolveComponent("MetafieldListItem")!
  const _component_MoreActions = _resolveComponent("MoreActions")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card-item', { 'card-item_list-view': _ctx.isFull, 'card-item_hoverable': _ctx.hoverable }])
  }, [
    (_ctx.selectable)
      ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          class: _normalizeClass(['card-item__select', { 'card-item__select_active': _ctx.selected }]),
          icon: "select",
          round: "",
          type: _ctx.selectButtonType,
          onClick: _withModifiers(_ctx.toggleSelect, ["stop"])
        }, null, 8, ["class", "type", "onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "card-item__image-wrapper",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action', 'show-info')))
    }, [
      (_ctx.thumbnail)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "card-item__image",
            src: _ctx.thumbnail,
            alt: "",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.thumbnailClickHandler && _ctx.thumbnailClickHandler(...args)))
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createBlock(_component_NIcon, {
            key: 1,
            class: "card-item__icon_unknown",
            name: _ctx.unknownIcon
          }, null, 8, ["name"]))
    ]),
    _createElementVNode("div", {
      class: "card-item__description",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('action', 'show-info')))
    }, [
      (_ctx.showName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click-on-name')))
            }, _toDisplayString(_ctx.cardName), 1),
            (_ctx.confidence)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.confidence.toFixed(3)), 1))
              : _createCommentVNode("", true),
            (_ctx.showMonitoring && _ctx.isPuppeteerEnabled && _ctx.isOnMonitoring)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('remote_monitoring.monitoring_letter', 'f')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFull)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.item.comment), 1))
        : _createCommentVNode("", true),
      (_ctx.item.license_plate_number)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.item.license_plate_number), 1))
        : _createCommentVNode("", true),
      (_ctx.autoCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('cards.autocards', 'f')), 1)
          ]))
        : (_openBlock(), _createBlock(_component_WatchListsGroup, {
            key: 4,
            items: _ctx.item.watch_lists,
            type: _ctx.displayType
          }, null, 8, ["items", "type"])),
      (_ctx.textComment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.textComment), 1))
        : _createCommentVNode("", true),
      (_ctx.isFull)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
            (_ctx.attachments.length)
              ? (_openBlock(), _createBlock(_component_NAttachments, {
                  key: 0,
                  attachments: _ctx.attachments,
                  class: "card-item__upload",
                  "disallow-attach": "",
                  "disallow-remove": "",
                  "hide-amount": ""
                }, null, 8, ["attachments"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_MetafieldListItem, {
                type: _ctx.type,
                item: _ctx.item
              }, null, 8, ["type", "item"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatDateTime(_ctx.item.created_date)), 1),
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.item.id), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isFull && _ctx.showMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_MoreActions, {
            actions: _ctx.itemActions,
            onAction: _cache[4] || (_cache[4] = (v) => _ctx.$emit('action', v))
          }, null, 8, ["actions"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isFull && _ctx.showShortComment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.item.comment), 1))
      : _createCommentVNode("", true)
  ], 2))
}